const HIGHLIGHT_COLORS = {
   MISSING_JUSTIFICATION: '#ffe6e6',
   REQUIRES_JUSTIFICATION: '#fff3cd',
   TOP_USER: '#FEFFE6'
};

const getRowStyle = (user, justificationIdNotFilled, usersRequiringJustification = new Set()) => {
   // Check if user requires justification based on real-time state management
   if (usersRequiringJustification.has(user.ID)) {
      return { backgroundColor: HIGHLIGHT_COLORS.MISSING_JUSTIFICATION };
   }

   // Check for top user highlighting
   const latestCalibration = user.CalibrationScores?.[user.CalibrationScores.length - 1];
   if (latestCalibration?.TopUser) {
      return { backgroundColor: HIGHLIGHT_COLORS.TOP_USER };
   }

   return {};
};

const getPreviousCalibration = (user) => {
   let scoreBefore = 0;
   let ratingBefore = "";
   let calLength = user.CalibrationScores.length - 2;

   while (calLength >= 0) {
      scoreBefore = user.CalibrationScores[calLength].CalibrationScore;
      ratingBefore = user.CalibrationScores[calLength].CalibrationRating;
      calLength--;

      if (scoreBefore && ratingBefore) break;
   }

   if (!scoreBefore && !ratingBefore) {
      scoreBefore = user.ActualScores[0]?.ActualScore;
      ratingBefore = user.ActualScores[0]?.ActualRating;
   }

   return { scoreBefore, ratingBefore };
};

const getChangedScoreClass = (user, calibratedScore) => {
   const { scoreBefore, ratingBefore } = getPreviousCalibration(user);
   const currentScore = calibratedScore[user.ID]?.CalibrationScore;
   const currentRating = calibratedScore[user.ID]?.CalibrationRating;

   const hasChanged =
      (user.ScoringMethod === 'Score' && scoreBefore !== currentScore) ||
      (user.ScoringMethod === 'Rating' && ratingBefore !== currentRating);

   return hasChanged ? "text-center highlight-change-score" : "text-center highlight";
};

const formatScore = (score) => {
   if (!score) return "-";
   return score.toFixed(2);
};

export { getRowStyle, getChangedScoreClass, formatScore, getPreviousCalibration };
